import { motion, Variants } from 'framer-motion';

interface OcdCycleCompassElementProps {
    children: React.ReactNode;
    position: 'north' | 'south' | 'east' | 'west';
    label: string;
    variants: Variants;
    currentStep: string;
}

export const OcdCycleCompassElement = ({ children, position, label, variants, currentStep }: OcdCycleCompassElementProps) => {
    const getPositionStyles = () => {
        const baseStyles = "absolute px-4 text-2xl flex flex-col items-center justify-center text-osGrey-4";

        switch (position) {
            case 'north':
                return `${baseStyles} top-3 left-1/2 -translate-x-1/2 -translate-y-1/2`;
            case 'south':
                return `${baseStyles} bottom-3 left-1/2 -translate-x-1/2 translate-y-1/2 rotate-180`;
            case 'east':
                return `${baseStyles} right-3 top-1/2 translate-x-1/2 -translate-y-1/2 rotate-90`;
            case 'west':
                return `${baseStyles} left-3 top-1/2 -translate-x-1/2 -translate-y-1/2 -rotate-90`;
            default:
                return baseStyles;
        }
    };

    return (
        <motion.div className={getPositionStyles()} variants={variants} animate={currentStep}>
            <motion.div
                className="text-sm font-semibold"
                variants={variants}
                animate={currentStep}
            >
                {label}
            </motion.div>
            <motion.div
                className="bg-white px-1 py-1 z-[-1]"
                variants={variants}
                animate={currentStep}
            >
                {children}
            </motion.div>
        </motion.div>
    );
};